import styled, { css } from "styled-components";
import { device } from "../../../constants";
import { Container as ContainerBS } from "react-bootstrap";
import { Nav as NavBS, Navbar } from "react-bootstrap";
import { BlogButton } from "../../blog/buttons/button";

export const LanguageWrapper = styled.div`
  svg path {
    fill: ${({ theme }) => theme.colors["neutral-07"]}!important;
  }

  .language-selector-container {
    margin: 0;
    padding: 0;

    &[data-open="true"] {
      .language-label {
        color: ${({ theme }) => theme.colors["neutral-01"]};
      }

      svg path {
        fill: ${({ theme }) => theme.colors["neutral-01"]}!important;
      }

      .language-option-row {
        margin: 0!important;
      }

      @media ${device.laptop} {
        .language-label {
          color: ${({ theme }) => theme.colors["neutral-07"]};
          margin-left: 0!important;
        }

        svg path {
          fill: ${({ theme }) => theme.colors["neutral-07"]}!important;
        }
      }
    }
  }

  .language-label {
    display: inline-flex;
    margin-right: 8px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors["neutral-07"]};
  }

  :is([data-theme="dark"] &) {
    .language-label {
      color: ${({ theme }) => theme.colors["neutral-01"]};
    }
  }

  :is(.dark &) {
    svg path {
      fill: ${({ theme }) => theme.colors["neutral-01"]}!important;
    }
  }
`;

export const Nav = styled(NavBS)`
  gap: 32px;
  padding: 8px;
  padding-top: 24px;
  flex-direction: column!important;

  @media ${device.laptop} {
    gap: 12px;
    padding: 0;
    flex-direction: row!important;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }

  @media ${device.laptopL} {
    gap: 32px;
  }
`;

export const NavLink = styled.a`
  ${({ theme }) => css`
    color: ${theme.colors["neutral-07"]};
  `}

  text-transform: uppercase;
  transition: color .3s;
  font-weight: 400;
  line-height: 24px;
  font-size: 14px;
  letter-spacing: 1.2px;
  text-decoration: none;

  &:hover {
    color: #4e4b98 !important;
  }

  @media ${device.laptop} {
    font-size: 12px;
  }

  @media ${device.laptopL} {
    font-size: 14px;
  }
`;

export const BrandImage = styled.img`
  display: inline-block;
  width: 150px;
  height: 48px;

  @media ${device.laptopL} {
    width: 190px;
  }
`;

export const ToggleThemeBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;

  img {
    width: 24px;
    height: 24px;
  }
`;

export const HeaderLoginButton = styled(BlogButton)`
  width: 139px;
  text-transform: uppercase;
  margin-left: auto;
  display: none;
  
  @media ${device.laptop} {
    display: flex;
  }
  
  @media ${device.laptopL} {
    margin-right: ${({ showTheme }) => (showTheme ? "24px" : "0")};
    min-width: 139px;
  }
`;

export const NavMobileWrapper = styled.div`
  padding: 0 18px;

  @media ${device.laptop} {
    padding: 0;
  }
`;

export const NavbarToggle = styled(Navbar.Toggle)`
  border: none;
  height: 40px;
  width: 40px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &.collapsing {
    height: inherit;
    width: 0;
    transition: width .35s ease;
  }

  &.navbar-toggler {
    display: flex !important;
  }

  @media ${device.laptop} {
    &.navbar-toggler {
      display: none !important;
    }
  }
`;

export const NavbarCollapse = styled(Navbar.Collapse)`
  position: fixed;
  align-items: flex-start;
  left: 0;
  top: 80px;
  background: ${({ theme }) => theme.colors["background-03"]};
  height: 100%;
  width: 85%;
  transform: translateX(-100%);
  transition: transform 0.35s ease;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  
  &.show {
    transform: translateX(0);
    max-width: 550px;
  }
  
  &.collapsing {
    transform: translateX(-100%);
    transition: transform 0.35s ease;
  }
  
  @media ${device.laptop} {
    box-shadow: none;
    position: initial;
    height: initial;
    width: 100%;
    transform: none;
    transition: none;
  }
`;

export const NavbarCustom = styled(Navbar)`
  background-color: ${({ theme }) => theme.colors["background-03"]};
  height: 80px;

  :is([data-theme="dark"] &) {
    ${({ theme }) => css`
      background-color: ${theme.colors["background-02"]};

      ${NavbarCollapse} {
        background-color: ${theme.colors["background-02"]};
      }

      ${NavLink} {
        color: ${theme.colors["neutral-01"]};
      }

      ${LanguageWrapper} {
        svg path {
          fill: ${theme.colors["neutral-01"]} !important;
        }
      }
    `}
  }

  &.transparent {
    background-color: transparent!important;

    ${NavbarCollapse} {
      background-color: transparent!important;
    }
  }

  &.dark {
    background-color: ${({ theme }) => theme.colors["background-02"]};

    ${NavbarCollapse} {
      background-color: ${({ theme }) => theme.colors["background-02"]};
    }
  }

  &.light {
    background-color: ${({ theme }) => theme.colors["background-03"]};

    ${NavbarCollapse} {
      background-color: ${({ theme }) => theme.colors["background-03"]};
    }
  }
`;

export const NavbarContainer = styled(ContainerBS)`
  position: relative;
  height: 100%;
  padding: 0 24px;

  .content {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .navbar-brand-link {
    cursor: pointer;
  }

  @media ${device.laptop} {
  }
`;
